import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import { RdsIsDataUsageAgreementPipeModule, RdsIsExternalDataAccessPipeModule, RdsIsRoleAccessPolicyPipeModule } from '../core/pipes';
import { RdsDataAccessPolicyDialogComponent } from './data-access-policy-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    FlexLayoutModule,
    RdsIsDataUsageAgreementPipeModule,
    RdsIsExternalDataAccessPipeModule,
    RdsIsRoleAccessPolicyPipeModule,
  ],
  exports: [RdsDataAccessPolicyDialogComponent],
  declarations: [RdsDataAccessPolicyDialogComponent],
})
export class RdsDataAccessPolicyDialogModule {}
